import React from 'react';

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  text: string;
}

const RoundedButton = ({ text, onClick, className, ...rest }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={'text-white font-raleway py-1 rounded-3xl ' + className}
      {...rest}
    >
      {text}
    </button>
  );
};

export default RoundedButton;
